export enum FlexwoningenEnum {
  FLEXWONINGEN = 'Flexwoningen',
  REGULIER_PERMANENT = 'Regulier permanent',
}
